import axios from "./api";
import config from "../utils/config";
import {
  IActivityInfo,
  IAddressDatum,
  IGetActivityParams,
} from "./activity/interface";

export interface IResponse<T> {
  status: string;
  data: T;
  description: string;
}

export interface IEnterList {
  avatar_list: Array<string>; // 头像列表
  enter_count: number; // 报名人数
}

export interface IUserCenterParams {
  activity_id: number; // 活动id
  goal_id?: number; // 目标id(单次活动使用)
  goods_id?: string;
  sign_up_items?: Array<{
    title: string;
    value: string;
  }>;
}

/**
 * 奖励类型： medal奖章 other其他 cert证书 real实物奖励 virtual虚拟奖励 sync_with_sign_page与报名页同步
 */
export type IProgressRewardType =
  | "medal"
  | "other"
  | "cert"
  | "real"
  | "virtual"
  | "sync_with_sign_page"
  | "new_comer_gift_pack";

export interface IRewordList {
  show?: boolean; // 是否展示奖励
  in_page_img?: string; // 奖励页面展示图片
  cert_desc?: string; // 证书目标
  cert_img?: string; // 证书头图
  cert_slogan?: string; // 证书宣誓语
  reward_type?: IProgressRewardType;
  reward_img?: string; // 实物、虚拟奖品图片
  reward_msg?: string; // 实物、虚拟奖品说明
  reward_url?: string;
  cer_finish_title?: string;
  cer_finish_desc?: string;
  /**
   * 【其它奖励 用】
   * 当活动为“完成多个目标”时，只能配置1个弹窗，仍用该字段表示弹窗图片（不支持“限量”）
   */
  pop_up_img?: string; // 弹窗展示图片
  /**
   * 【其它奖励 用】
   * 当活动为“完成单个目标”时，活动有几个阶段，就要配几个弹窗（每个阶段对应一个弹窗）（支持“限量”的配置）
   */
  goal_reward_list: IGoalRewardItem[];
  // 新人礼包
  new_comer_gift_pack_reward: {
    pack_items: IPackItem[];
    share_feed_img: string;
    share_feed_title: string;
    share_reward_type: number;
    share_reward_value: string;
    share_title: string;
  };
}

export interface IPackItem {
  button_text: string
  jump_url: string
  text: string
  type: number
  value: string
  count_down: number
  image: string
}

/* 其它奖励、单个目标 的奖励配置 */
export type IGoalRewardItem = {
  goal_id: number;
  pop_up_img: string; // 弹窗图
  reward_url: string; // 跳转链接（非必填）
  limit_count: number; // 限量（不填不限量）
};

export interface IRewardItem {
  title: string; // 标题
  sub_title: string; // 副标题
  reward_img: string; // 奖励图
}

export interface IPostCreateTempDetail {
  activity_intro: {
    show?: boolean; // 是否显示活动介绍
    content?: string; // 活动介绍内容
    title?: string; // 活动介绍标题
  };
  head_img: {
    img_url: string; // 头图
  };
  progress: {
    show_type: 1; // 是否显示进度条 1 展示
  };
  reward_info: {
    show: boolean; // 活动奖励是否展示
    reward_items: IRewardItem[];
    title: string; // 活动奖励标题
  };
  reword_list: IRewordList;
  rule_info: {
    show: boolean;
    content: string; // 活动规则内容
    title: string; // 活动规则标题
  };
  share_param: {
    content: string; // 分享内容
    title: string; // 分享标题
  };
  sports_record: {
    show?: boolean; // 是否展示运动记录
  };
  act_intro_ing: {
    show?: boolean; // 进行页是否展示活动介绍
  };
  start_btn: {
    url_valid?: boolean; // 链接是否合法
    to_url?: string; // 运动开始按钮跳转url
  };
  topic: {
    show?: boolean; // 是否展示话题
    title?: string; // 参与话题标题
    topic_id?: number; // 话题id
  };
  card_info: {
    // 活动信息卡片
    card_color?: string; // 卡片颜色（老的活动可能没有）
    card_bg_color?: string; // 卡片背景颜色（老的活动可能没有）
    button_color?: string; // 按钮颜色
  };
  sign_up_info?: {
    items: {
      required: boolean;
      title: string;
      placeholder: string;
      input_type: string;
    }[];
  };
}

export interface IGetLabelFeedParams {
  label_id?: number;
  limit: number;
}

export interface IFeedDetailView {
  nick: string; // 昵称
  user_id: string; // user_id
  portrait: string; // 用户头像
  pics: IFeedSimplePic[]; // 图片集合
  select_feed_pic_id: number; // 精选图片id
  create_time: string; // 创建时间
  feed_id: string; // feedid
  codoon_url: string; // 跳转链接
  content: string; // feed内容
}

export interface IFeedSimplePic {
  pic_id: number; // 图片id
  pic_type: number; // 类型 0 普通feed 1 卡片图片 3 视频地址 4 视频动图封面
  size: string; // 图片尺寸
  url: string; //  图片地址
}

export interface IRouteListItem {
  route_url: string; // 路线详情地址(跳转详情)
  sports_type: string; // 运动类型 0健走 1跑步 2骑行 6健身
  start_time: string; // 开始时间(2006-01-02 15:04:05) ,
  total_calorie: number; // 千卡
  total_length: number; // 总距离(m) ,
  total_time: number; // 总时间(s)
  race: number; // 配速(s)
}

export interface IMedalInfo {
  code: string; // Code
  img: string; // 图片
  name: string; // 奖章名称
}

export interface IUserinfo {
  nick: string;
  portrait: string;
  id: string;
}

export interface IQueryAddressesResponse {
  data: IAddressDatum[];
  status: {
    msg: string;
    state: number;
  };
}

/**
 * 获取一个市下有哪些区
 */
export interface ICounty {
  id: number;
  name: string;
}

export interface IQueryCountyInfoResponse {
  data: ICounty[];
  status: {
    msg: string;
    state: number;
  };
}

// 更新收货地址
interface IUpdateAddressParams {
  activity_id: number; // 活动id
  address: string;
  act_type: number; // 活动类型
}

export default {
  // 通过 电商接口 获取收货地址
  queryAddresses(): Promise<IQueryAddressesResponse> {
    return axios.get(
      "https://xmall.codoon.com/api/mall/webmall/query_all_recv_info?module=mall"
    );
  },

  // 通过 电商接口 获取一个市下有哪些区
  queryCountyInfo(cityId: string): Promise<IQueryCountyInfoResponse> {
    return axios.get(
      `https://xmall.codoon.com/api/mall/webmall/county_info?module=mall&city_id=${cityId}`
    );
  },

  // 更新收货地址
  updateAddress(params: IUpdateAddressParams): Promise<IResponse<undefined>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/update_address`,
      params
    );
  },

  // 获取活动详情
  getMyActivity(params: IGetActivityParams): Promise<IResponse<IActivityInfo>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_my_activity`,
      params
    );
  },

  // 获取活动参与人数
  getEnterList(params: IGetActivityParams): Promise<IResponse<IEnterList>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_enter_list`,
      params
    );
  },

  // 提交报名
  postUserEnter(params: IUserCenterParams): Promise<IResponse<{}>> {
    return axios.post(`${config.baseUrl}/www/codoon_act/user_enter`, params);
  },

  // 获取训练模版详情
  getActivityTemplate(
    params: IGetActivityParams
  ): Promise<
    IResponse<{ detail: IPostCreateTempDetail; medals: IMedalInfo[] }>
  > {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/activity_template`,
      params
    );
  },

  // 获取话题feed
  getFeedsByLabel(params: IGetLabelFeedParams): Promise<
    IResponse<{
      normal_feed_list: IFeedDetailView[];
      label: { label_content: string };
    }>
  > {
    return axios.get(
      `${config.baseUrl}/web/feedserver/8.22.0/get_feed_by_label`,
      {
        params,
        // 未登录 401 时不要触发全局跳登录
        validateStatus: (status: number) => status < 500,
      }
    );
  },

  // 获取运动记录
  getRouteList(
    params: IGetActivityParams
  ): Promise<IResponse<IRouteListItem[]>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_route_list`,
      params
    );
  },

  // 获取完成数
  getCompleteCount(
    params: IGetActivityParams
  ): Promise<IResponse<{ complete_count: number }>> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/get_complete_count`,
      params
    );
  },

  // 获取用户信息
  getUserInfo(): Promise<IResponse<IUserinfo>> {
    return axios.get(`${config.baseUrl}/ugcserver/index`);
  },

  // raceUrl
  uploadImg(params: { file: string }): Promise<IResponse<{ url: string }>> {
    return axios.post(`${config.raceUrl}/save_base64_to_url`, params);
  },

  // 上传三方图片
  uploadThirdImage(params: { url: string }): Promise<{
    desc: string;
    status: boolean;
    data: { url: string };
  }> {
    return axios.get(
      `https://race.codoon.com/third/race/qdrace/tool/upload/third_img`,
      {
        params,
      }
    );
  },

  /**
   * 获取base64格式图片地址
   * @param params
   */
  getBase64PicUrl(params: { url: string }): Promise<{
    desc: string;
    status: boolean;
    data: string;
  }> {
    return axios.get(
      `//www.codoon.com/activity/v1/equipment_api/outside-img/base64`,
      {
        params,
      }
    );
  },

  // 上传base64图片
  uploadBase64Img(params: {
    data: string;
    type: string;
  }): Promise<{ status: boolean; data: "" }> {
    return axios.post(
      `//www.codoon.com/activity/v1/api/upload/dataurl`,
      params
    );
  },

  // 手动领取奖励(新手礼包)
  getNewUserGift(params: IGetActivityParams): Promise<{
    description: string;
    status: string;
  }> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/obtain_rewards`,
      params
    );
  },

  // 新手礼包里面的会员优惠券状态
  getNewUserGiftCoupon(params: IGetActivityParams): Promise<{
    description: string;
    status: string;
    data: { state: number, items: { count_down_end_time: string, index: number }[] }
  }> {
    return axios.get(
      `${config.baseUrl}/www/codoon_act/query_rewards_status`,
      { params }
    );
  },

  // 新手礼包里面的会员优惠券状态
  getNewUserGoShare(params: IGetActivityParams): Promise<{
    description: string;
    status: string;
  }> {
    return axios.post(
      `${config.baseUrl}/www/codoon_act/new_comer_share`,
      params
    );
  },
};
